import zPage from '../Page/page.vue';
import comList from '../../components/com-list.vue';
export default{
    name:'HomeSearch',
    data(){
        return{
            page:{
                targetPage:1,
                pageSize:10,
                totalPage:0,
                type:2,
            },
            list:[],
            word:'',
            text:'',
            loading:false,
        }
    },
    components:{
        zPage,
        comList,
    },
    watch:{
        '$store.state.search.search':function(){
            this.word=this.$store.state.search.search;
            this.getData();
        }
    },
    created(){
        this.initData();
    },
    methods:{
        initData(){
            this.word=this.$route.query.input;
            this.getData();
        },
        search(){
            this.word=this.word;
            this.getData();
        },
        getData(){
            this.loading=true;
            var body={
                pageNumber:this.page.targetPage-1,
                pageSize:this.page.pageSize,
                word:this.word,
            };
            this.get(this.api.homeSearch,body).then(res=>{
                if(res.result==200){
                    this.list=res.data.list;
                    for(var i =0;i<this.list.length;i++){
                        this.list[i].infoTitle=this.list[i].title;
                        this.list[i].createDate=this.list[i].publishDate.substring(0,10);
                    }
                    this.page.totalPage=res.data.totalElements;
                    this.text=this.word;
                    this.loading=false;
                }
            }).catch(err=>{
                this.loading=false;
            });
        },
        getDetail(type,item){
            this.$router.push({path:'/homeDetail',query:{type:type,item:item}});
        },
    }
}